import { apolloService } from '@/apollo/apolloRequests';
import { queries } from '@/apollo';
import { Query } from '@/generated/graphql';

export function useRetrievePeriodWithSubfolders() {
  const fetchPeriodWithSubfolders = async (periodFolderId: string) => {
    try {
      return (await apolloService.makeApolloRequest('query', queries.GET_PERIOD_WITH_SUBFOLDERS, {
        idPeriodFolder: periodFolderId,
      })) as Query;
    } catch (error) {
      console.error('Error fetching period data:', error);
      throw error;
    }
  };

  return {
    fetchPeriodWithSubfolders,
  };
}
